var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashbordMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0527 2.60547H5.94727C2.66786 2.60547 0 5.27333 0 8.55273V17.7383C0 20.355 1.71803 22.6341 4.20756 23.3636L7.07986 26.2361C7.23938 26.3954 7.45532 26.485 7.68078 26.485C7.90601 26.485 8.12218 26.3954 8.28148 26.2361L10.9164 23.601H23.0527C26.3321 23.601 29 20.9331 29 17.6537V8.55273C29 5.27333 26.3321 2.60547 23.0527 2.60547ZM27.3008 17.6537C27.3008 19.9961 25.3951 21.9018 23.0527 21.9018H10.5646C10.3393 21.9018 10.1232 21.9914 9.96388 22.1507L7.68078 24.4338L5.24921 22.0022C5.14014 21.8932 5.0034 21.8157 4.85361 21.7785C2.99642 21.3163 1.69922 19.655 1.69922 17.7383V8.55273C1.69922 6.21033 3.60487 4.30469 5.94727 4.30469H23.0527C25.3951 4.30469 27.3008 6.21033 27.3008 8.55273V17.6537Z",
    fill: "#92A4D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8946 10.752H9.10547C8.63619 10.752 8.25586 11.1325 8.25586 11.6016C8.25586 12.0708 8.63619 12.4512 9.10547 12.4512H19.8946C20.3639 12.4512 20.7442 12.0708 20.7442 11.6016C20.7442 11.1325 20.3639 10.752 19.8946 10.752Z",
    fill: "#92A4D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8946 13.7554H9.10547C8.63619 13.7554 8.25586 14.1357 8.25586 14.605C8.25586 15.0743 8.63619 15.4546 9.10547 15.4546H19.8946C20.3639 15.4546 20.7442 15.0743 20.7442 14.605C20.7442 14.1357 20.3639 13.7554 19.8946 13.7554Z",
    fill: "#92A4D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbordMessageIcon);
export default __webpack_public_path__ + "static/media/dashbord-message-icon.fa885a22db0d777b017c8c3d64e52c89.svg";
export { ForwardRef as ReactComponent };